import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function Sites() {
  const [sites, setSites] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [name, setName] = useState('');
  const [domain, setDomain] = useState('');
  const [deletingSite, setDeletingSite] = useState(null);

  const load = () => api('/analytics/sites').then(r => r.ok ? r.json() : []).then(setSites).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    const res = await api('/analytics/sites', { method: 'POST', body: JSON.stringify({ name: name.trim(), domain: domain.trim() || null }) });
    if (res.ok) { setShowCreate(false); setName(''); setDomain(''); load(); }
  };

  const handleDelete = async () => {
    if (!deletingSite) return;
    await api(`/analytics/sites/${deletingSite.id}`, { method: 'DELETE' });
    setDeletingSite(null);
    load();
  };

  return (
    <Layout>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Sites</h2>
        <button onClick={() => setShowCreate(true)} className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700">
          Add Site
        </button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Name</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Domain</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Pageviews</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden sm:table-cell">Calls</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {sites.map(site => (
              <tr key={site.id} className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <Link to={`/analytics/sites/${site.id}`} className="text-amber-600 hover:text-amber-800 font-medium">{site.name}</Link>
                </td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{site.domain || '—'}</td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{site.pageviewCount || 0}</td>
                <td className="px-6 py-4 text-gray-600 hidden sm:table-cell">{site.callCount || 0}</td>
                <td className="px-6 py-4 text-right">
                  <button onClick={() => setDeletingSite(site)} className="text-sm text-red-600 hover:text-red-800">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {sites.length === 0 && <div className="text-center py-12 text-gray-500">No sites yet. Add one to get started.</div>}
      </div>

      {showCreate && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowCreate(false)}>
          <form onSubmit={handleCreate} onClick={e => e.stopPropagation()} className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Add Site</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Site Name</label>
                <input autoFocus type="text" value={name} onChange={e => setName(e.target.value)}
                  placeholder="My Website" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Domain (optional)</label>
                <input type="text" value={domain} onChange={e => setDomain(e.target.value)}
                  placeholder="example.com" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 outline-none" />
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-4">
              <button type="button" onClick={() => setShowCreate(false)} className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg">Cancel</button>
              <button type="submit" disabled={!name.trim()} className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 disabled:opacity-50">Create</button>
            </div>
          </form>
        </div>
      )}

      {deletingSite && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setDeletingSite(null)}>
          <div onClick={e => e.stopPropagation()} className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md mx-4">
            <h3 className="text-lg font-bold text-gray-900 mb-2">Delete Site</h3>
            <p className="text-gray-600 mb-6">Are you sure you want to delete "{deletingSite.name}" and all its data? This action cannot be undone.</p>
            <div className="flex justify-end gap-3">
              <button onClick={() => setDeletingSite(null)} className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</button>
              <button onClick={handleDelete} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Delete</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
